let SoundManager = {
    mute: false,
    PlayBallHit: function(){
        if (SoundManager.mute == false){
            //TODO:play sound with react
            // $("#audios").append("<audio autoplay><source src='../Models/Sounds/shot2.ogg' /><source src='../Models/Sounds/shot2.mp3' /></audio>");

            const el:any = document.getElementById("ball-hit") as HTMLAudioElement;
            el.cloneNode(true).play();
        }
    }
};

export default SoundManager;